import { clearEntitlementsFromStorage } from './entitlementsStorage';
import { clearCapabilitiesFromStorage } from './capabilitiesStorage';
import { clearAuthFromStorage } from './authStorageHelper';
import { clearPhoneFromStorage, clearWabaIdsFromStorage, clearCategoriesFromStorage, clearPlansFromStorage } from './apiCacheHelper';

export const clearSessionStorage = () => {
  sessionStorage.removeItem('waba_id');
  sessionStorage.removeItem('exportRequestedTimestamp');
};

export const clearStorage = () => {
  clearEntitlementsFromStorage();
  clearCapabilitiesFromStorage();
  clearAuthFromStorage();
  clearPhoneFromStorage();
  clearWabaIdsFromStorage();
  clearCategoriesFromStorage();
  clearPlansFromStorage();
  clearSessionStorage();
  localStorage.removeItem('userRole');
};
